export const cookie = {
	set(name,value,days) {
		var d = new Date;
		d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
		let cookieString = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        //cookieString = cookieString +';domain=motherbuy.com;'
		window.document.cookie = cookieString;
	},
	get(name){
		var value = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    	return value ? value[2] : null;
	},
	delete(name){
		this.set(name, '', -1);
	}
}